import { render, staticRenderFns } from "./AllPackagesSection.vue?vue&type=template&id=25dcefea&scoped=true&"
import script from "./AllPackagesSection.vue?vue&type=script&lang=ts&"
export * from "./AllPackagesSection.vue?vue&type=script&lang=ts&"
import style0 from "./AllPackagesSection.vue?vue&type=style&index=0&id=25dcefea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dcefea",
  null
  
)

export default component.exports